// ── Session Shape ──
export const WARMUP_COUNT = 3;
export const CONSOLIDATION_COUNT = 3;
export const MAX_SESSION_QUESTIONS = 25;
export const DEFAULT_SESSION_MINUTES = 20;
export const NEW_VS_REVIEW_RATIO = 0.3;

// ── FSRS Defaults ──
export const DEFAULT_DIFFICULTY = 5.0;
export const DEFAULT_STABILITY = 0;
export const MASTERED_STABILITY_DAYS = 7;

// ── BKT Defaults (Phase 2) ──
export const BKT_P_L0 = 0.3;      // Initial mastery probability
export const BKT_P_T = 0.1;       // Probability of learning per opportunity
export const BKT_P_G = 0.25;      // Probability of guessing correctly
export const BKT_P_S = 0.1;       // Probability of slipping

// ── BKT Mastery Thresholds ──
export const MASTERY_INTENSIVE = 0.6;   // Below: intensive practice
export const MASTERY_SPACED = 0.9;      // Below: spaced review; above: mastered

// ── Fatigue Detection (Phase 3) ──
export const FATIGUE_MIN_SESSIONS = 3;
export const FATIGUE_WINDOW_SIZE = 7;
export const FATIGUE_SHIFT_THRESHOLD = 1.5;  // stddev above baseline
export const FATIGUE_END_THRESHOLD = 2.0;
export const FATIGUE_MIN_POSITION = 5;

// ── autoRating Base Response Times (ms) ──
export const BASE_RT = {
  'mcq': 20000,
  'yes-no': 10000,
  'drag-order': 40000,
  'drag-match': 35000,
  'scenario-select': 30000,
  'scenario-multi': 35000
};

// ── Complexity Multipliers ──
export const COMPLEXITY_MULTIPLIER = {
  1: 0.8,
  2: 1.0,
  3: 1.3
};

// ── Default Domain Weights (used when certSpec doesn't provide weights) ──
// Equal distribution fallback — certSpec should always override this
export const DEFAULT_DOMAIN_WEIGHTS = {
  1: 0.25,
  2: 0.25,
  3: 0.25,
  4: 0.25
};

// ── Engine Activation: Data-Driven Gating ──
// Engine activates when question bank has minimum metadata
export function hasMinimumMetadata(questions) {
  if (!questions || questions.length < 10) return false;
  // Sample 10 questions — check for required fields
  var sample = questions.slice(0, Math.min(10, questions.length));
  var hasIrt = sample.every(function(q) { return q.irtDifficulty !== undefined; });
  var hasSkills = sample.every(function(q) { return q.skills && q.skills.length > 0; });
  var hasDomain = sample.every(function(q) { return q.domain !== undefined; });
  return hasIrt && hasSkills && hasDomain;
}

// ── Weakness Forecast Weights ──
export const FORECAST_WEIGHT_IRT = 0.40;
export const FORECAST_WEIGHT_BKT = 0.30;
export const FORECAST_WEIGHT_FSRS = 0.20;
export const FORECAST_WEIGHT_KG = 0.10;
export const REINFORCEMENT_THRESHOLD = 0.55;

// ── Concept Propagation (Phase 2) ──
export const PROPAGATION_MIN_OVERLAP = 2;
export const PROPAGATION_FULL_BOOST = 0.50;    // 3/3 shared tags
export const PROPAGATION_PARTIAL_BOOST = 0.25;  // 2/3 shared tags
